import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as Cookies from "js-cookie";
import {ConstantsService as constants} from "../../services/constants/constants.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {OrganisationService} from "../../services/organisation/organisation.service";
import { PermissionsService } from '../../services/permissions/permissions.service';

@Component({
  selector: 'app-nps',
  templateUrl: './nps.component.pug',
  styleUrls: ['./nps.component.scss'],
  standalone: false
})
export class NpsComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() response_count!: any;
  @Input() questionnaire!: any;
  @Input() filterBy!: any;
  @Input() pause_load = false;
  org_uid = Cookies.get(constants.ORG_COOKIE);
  org_brand_name: any;

  constructor(
    private organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    // @ts-ignore
    this.organisationService.getOrganisation().subscribe(res => {
      this.org_brand_name = res.brand_name;
      },
        (err: any) => {
            console.log(err);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          })
  }


  ngOnChanges(changes: SimpleChanges): void {
  }

}
